module.exports = __webpack_public_path__ + "static/legacy_card_img1@2x-cba674eb3229cd9578e28704db336d02.png";